// Tiny <picture> wrapper for the screenshots in public/screenshots/.
// WebP-first with a JPG fallback for browsers that don't speak WebP
// (a few percent of traffic). All assets are resized + recompressed
// by scripts/optimize-screenshots.js — re-run that script after
// dropping a new screenshot in public/screenshots/.
//
// width / height should be the natural pixel dimensions of the JPG
// after optimization (currently 700-wide) so the browser can reserve
// aspect-ratio'd space and avoid layout shift on first paint.

import React from 'react';

export const Screenshot = ({
  name,            // base filename without extension, e.g. 'home'
  alt,
  eager = false,
  width = 520,
  height,
  style,
  className,
}) => (
  <picture>
    <source srcSet={`/screenshots/${name}.webp`} type="image/webp" />
    <img
      src={`/screenshots/${name}.jpg`}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding={eager ? 'auto' : 'async'}
      // React 19 canonicalizes this prop as `fetchPriority` (camel-
      // case). Lowercase `fetchpriority` would get warned + dropped.
      // Eager images are LCP candidates; high priority tells the
      // browser to schedule the fetch ahead of other resources.
      fetchPriority={eager ? 'high' : undefined}
      width={width}
      height={height}
      className={className}
      style={style}
    />
  </picture>
);

export default Screenshot;
